<template>
  <van-tabs class="course-tabs" v-model="active">

    <van-tab title="课程">
      <van-list class="px-3 pt-1 bg-white cor-adv-list"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getTeacherById">
        <row-card-component :cardList="courseList" typeBlock="zl_course"
                            class="pb-28 border-bottom-0 mt-20">
        </row-card-component>
      </van-list>
    </van-tab>
    <van-tab title="详情">
      <div class="px-3 pt-1 bg-white color-33">
        <img class="w-100" src="/static/img/pro/jian1.png">
        <img class="w-100" src="/static/img/pro/jian2.png">
      </div>
    </van-tab>
  </van-tabs>
</template>

<script>
  import Vue from 'vue';
  import {Icon} from 'vant';
  import {List} from 'vant';
  import {Cell, CellGroup} from 'vant';
  import {Tab, Tabs} from 'vant';
  import RowCardComponent from "@/components/rowCardComponent";
  Vue.use(Tab);
  Vue.use(Tabs);
  Vue.use(Cell);
  Vue.use(CellGroup);
  Vue.use(List);
  Vue.use(Icon);

  export default {
    name: "courseIntroComponent",
    data() {
      return {
        active: 0,
        courseList: [],
        loading: false,
        finished: false
      }
    },
    components: {
      RowCardComponent
    },
    mounted() {
    },
    methods: {
      getTeacherById() {
        this.loading = true;
        this.$store.dispatch('getLectureById').then((res) => {
          this.courseList = res[0].courseList;
          this.loading = false;
          this.finished = true;
        })
      }
    }
  }
</script>

<style>

</style>
